import { createSelector } from 'reselect'
import { RootState } from '../types/rootstate'

export const allPopularQuestionsSelector = (state: RootState) => state.popularQuestions

export const popularQuestionsSelector = (state: RootState, props) => {
  const key = `${props.categoryId}${props.numberOfItems}`
  return (state.popularQuestions[key] && state.popularQuestions[key].popularQuestions) || []
}

export const popularQuestionsStatusSelector = (state: RootState, props) => {
  const key = `${props.categoryId}${props.numberOfItems}`
  return (state.popularQuestions[key] && state.popularQuestions[key].status) || 'none'
}
